import { render, staticRenderFns } from "./SidebarBalance.vue?vue&type=template&id=08e1d4b0&scoped=true"
import script from "./SidebarBalance.vue?vue&type=script&lang=js"
export * from "./SidebarBalance.vue?vue&type=script&lang=js"
import style0 from "./SidebarBalance.vue?vue&type=style&index=0&id=08e1d4b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e1d4b0",
  null
  
)

export default component.exports